import axios from "axios";
import {
  Branch_Gst_Verification_URL,
  Lead_Service_URL,
  Master_Service_URL,
  Partner_Service_URL,
} from "../Url";
import HashMap from "hashmap";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const saveAddLeadActions = {
  SAVE_ADD_LEAD_DETAILS_SUCCESS: "SAVE_ADD_LEAD_DETAILS_SUCCESS",
  SAVE_ADD_LEAD_DETAILS_ERROR: "SAVE_ADD_LEAD_DETAILS_ERROR",
};

export function saveAddLeadDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/addLead`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAddLeadSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAddLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAddLeadError(err));
          return err.response;
        }
      });
}

export function saveAddLeadError(error) {
  return {
    type: saveAddLeadActions.SAVE_ADD_LEAD_DETAILS_ERROR,
    payload: error,
  };
}

export function saveAddLeadSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveAddLeadActions.SAVE_ADD_LEAD_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

//   masterLead Dropdown

export const LeadMasterListActions = {
  LEAD_MASTER_LIST: "LEAD_MASTER_LIST",
  LEAD_MASTER_LIST_SUCCESS: "LEAD_MASTER_LIST_SUCCESS",
  LEAD_MASTER_LIST_ERROR: "LEAD_MASTER_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getLeadMasterList(props) {
  const { access_token, name, url } = props;
  // let endpoint = "";
  // if (url) {
  //   endpoint = `${Lead_Service_URL}/get/${url}/${name}`;
  // }
  // else {
  //   endpoint = `${Lead_Service_URL}/listing/SystemValueMasters`;
  // }
  // // if(url){
  // //       endpoint = `${System_URL}/listing/SystemValueMasters`;
  // // }
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/getAll/getAllLeadMaster`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getLeadMasterListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getLeadMasterListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getLeadMasterListError(err));
          return err.response;
        }
      });
}

export function getLeadMasterListRequest() {
  return {
    type: LeadMasterListActions.LEAD_MASTER_LIST,
    isPosting: true,
  };
}
export function getLeadMasterListError(error) {
  return {
    type: LeadMasterListActions.LEAD_MASTER_LIST_ERROR,
    payload: error,
  };
}

export function getLeadMasterListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: LeadMasterListActions.LEAD_MASTER_LIST_SUCCESS,
      payload: props,
    });
  };
}

// all branchDetails pincode
export const sideBarBranchActions = {
  SIDE_BAR_BRANCH_SUCCESS: "SIDE_BAR_BRANCH_SUCCESS",
  SIDE_BAR_BRANCH_ERROR: "SIDE_BAR_BRANCH_ERROR",
};

export function getSideBarBranch(props) {
  const { accessToken, partnerFirmId, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Gst_Verification_URL}/getAllBranchDetailsByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SideBarBranchSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SideBarBranchError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        dispatch(SideBarBranchError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function SideBarBranchError(error) {
  return {
    type: sideBarBranchActions.SIDE_BAR_BRANCH_ERROR,
    payload: error,
  };
}

export function SideBarBranchSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: sideBarBranchActions.SIDE_BAR_BRANCH_SUCCESS,
      payload: props,
    });
  };
}

export const searchCourseDetailActions = {
  SEARCH_COURSE_DETAIL_LOADING: "SEARCH_COURSE_DETAIL_LOADING",
  SEARCH_COURSE_DETAIL_SUCCESS: "SEARCH_COURSE_DETAIL_SUCCESS",
  SEARCH_COURSE_DETAIL_ERROR: "SEARCH_COURSE_DETAIL_ERROR",
};

export function searchCourseDetail(props) {
  const { access_token, params } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
      },
      url: `${Master_Service_URL}/search/Course`,

      params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SearchCourseDetailSuccess(response.data));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(SearchCourseDetailError(error));
          throw error;
        }
      })
      .catch((err) => {
        dispatch(SearchCourseDetailError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else if (!err.response) {
          // console.log(err);
        }
      });
}

export function SearchCourseDetailError(error) {
  return {
    type: searchCourseDetailActions.SEARCH_COURSE_DETAIL_ERROR,
    payload: error,
  };
}

export function SearchCourseDetailSuccess(props) {
  return {
    type: searchCourseDetailActions.SEARCH_COURSE_DETAIL_SUCCESS,
    payload: props,
  };
}

export function SearchCourseDetailLoading(props) {
  return {
    type: searchCourseDetailActions.SEARCH_COURSE_DETAIL_LOADING,
    payload: props,
  };
}

export const searchUniversityDetailActions = {
  SEARCH_UNIVERSITY_DETAIL_LOADING: "SEARCH_UNIVERSITY_DETAIL_LOADING",
  SEARCH_UNIVERSITY_DETAIL_SUCCESS: "SEARCH_UNIVERSITY_DETAIL_SUCCESS",
  SEARCH_UNIVERSITY_DETAIL_ERROR: "SEARCH_UNIVERSITY_DETAIL_ERROR",
};

export const searchUniversityDetails =
  (props) => async (dispatch, getState) => {
    const access_token = props.access_token ?? getState()?.auth?.idToken;

    const { params } = props;

    dispatch(SearchUniversityDetailLoading(true));

    return axios({
      method: "post",
      url: `${Master_Service_URL}/search/University`,
      headers: {
        authorization: "Bearer " + access_token,
      },
      params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SearchUniversityDetailSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SearchUniversityDetailError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(SearchUniversityDetailError(err));
          return err.response;
        }
      });
  };

export const SearchUniversityDetailLoading = () => {
  return {
    type: searchUniversityDetailActions.SEARCH_UNIVERSITY_DETAIL_LOADING,
  };
};

export const SearchUniversityDetailSuccess = (props) => {
  return {
    type: searchUniversityDetailActions.SEARCH_UNIVERSITY_DETAIL_SUCCESS,
    payload: props,
  };
};

export const SearchUniversityDetailError = (props) => {
  return {
    type: searchUniversityDetailActions.SEARCH_UNIVERSITY_DETAIL_ERROR,
    payload: props,
  };
};

export const searchCollegeDetailActions = {
  SEARCH_COLLEGE_DETAIL_LOADING: "SEARCH_COLLEGE_DETAIL_LOADING",
  SEARCH_COLLEGE_DETAIL_SUCCESS: "SEARCH_COLLEGE_DETAIL_SUCCESS",
  SEARCH_COLLEGE_DETAIL_ERROR: "SEARCH_COLLEGE_DETAIL_ERROR",
};

export const searchCollegeDetails = (props) => async (dispatch, getState) => {
  const access_token = props.access_token ?? getState()?.auth?.idToken;

  const { params } = props;

  dispatch(SearchCollegeDetailLoading(true));

  return axios({
    method: "post",
    url: `${Master_Service_URL}/search/Institute`,
    headers: {
      authorization: "Bearer " + access_token,
    },
    params: params,
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(SearchCollegeDetailSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(SearchCollegeDetailError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(SearchCollegeDetailError(err));
        return err.response;
      }
    });
};

export const SearchCollegeDetailLoading = () => {
  return {
    type: searchCollegeDetailActions.SEARCH_COLLEGE_DETAIL_LOADING,
  };
};

export const SearchCollegeDetailSuccess = (props) => {
  return {
    type: searchCollegeDetailActions.SEARCH_COLLEGE_DETAIL_SUCCESS,
    payload: props,
  };
};

export const SearchCollegeDetailError = (props) => {
  return {
    type: searchCollegeDetailActions.SEARCH_COLLEGE_DETAIL_ERROR,
    payload: props,
  };
};

export const leadActivationDetailsActions = {
  LEAD_ACTIVE_DATA_SUCCESS: "LEAD_ACTIVE_DATA_SUCCESS",
  LEAD_ACTIVE_DATA_ERROR: "LEAD_ACTIVE_DATA_SUCCESS",
};

export function leadActivationDetailsDetails(props) {
  const { access_token, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/get/PartnerDetails/ByPartnerFirmIdForLead?partnerFirmId=${partnerFirmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(leadActivationDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(leadActivationDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(leadActivationDetailsError(err));
          return err.response;
        }
      });
}

export function leadActivationDetailsError(error) {
  return {
    type: leadActivationDetailsActions.LEAD_ACTIVE_DATA_ERROR,
    payload: error,
  };
}

export function leadActivationDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: leadActivationDetailsActions.LEAD_ACTIVE_DATA_SUCCESS,
      payload: props,
    });
  };
}
